module.exports = __webpack_public_path__ + "static/media/LogoText.45c71011.png";